(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abc-artist-files"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const root=document.querySelector('[data-abc-files]');
    if(!root)return;
    const player=root.querySelector('[data-af-player]');
    const stage=root.querySelector('[data-af-stage]');
    const now=root.querySelector('[data-af-now]');
    const fine=window.matchMedia('(hover: hover) and (pointer: fine)');

    // preload="none" until the pointer arrives, so a page of films costs one poster each
    function preview(cell,on){
      const video=cell.querySelector('.abc-af-video');
      if(!video)return;
      if(on){
        if(!video.src)video.src=video.dataset.afLazy;
        const playing=video.play();
        if(playing&&playing.catch)playing.catch(()=>{});
        cell.classList.add('is-playing');
      }else{
        video.pause();
        try{video.currentTime=0;}catch(e){}
        cell.classList.remove('is-playing');
      }
    }
    root.querySelectorAll('.abc-af-cell').forEach(cell=>{
      cell.addEventListener('pointerenter',()=>{if(fine.matches)preview(cell,true);});
      cell.addEventListener('pointerleave',()=>preview(cell,false));
    });

    // The index takes you to a film rather than filtering the wall.
    root.querySelectorAll('[data-af-goto]').forEach(link=>{
      link.addEventListener('click',()=>{
        const cell=document.getElementById(link.dataset.afGoto);
        if(!cell)return;
        root.querySelectorAll('.abc-af-cell').forEach(other=>{
          preview(other,false);
          other.classList.remove('is-target');
        });
        cell.scrollIntoView({block:'center',behavior:'smooth'});
        cell.classList.add('is-target');
        if(fine.matches)preview(cell,true);
        setTimeout(()=>cell.classList.remove('is-target'),2400);
      });
    });

    function open(src,name){
      root.querySelectorAll('.abc-af-cell').forEach(cell=>preview(cell,false));
      stage.src=src;now.textContent=name||'';
      player.hidden=false;
      document.documentElement.style.overflow='hidden';
      stage.play().catch(()=>{});
    }
    function close(){
      stage.pause();stage.removeAttribute('src');stage.load();
      player.hidden=true;
      document.documentElement.style.overflow='';
    }
    root.addEventListener('click',event=>{
      const opener=event.target.closest('[data-af-src]');
      if(opener){open(opener.dataset.afSrc,opener.dataset.afName);return;}
      if(event.target.closest('[data-af-close]')||event.target===player)close();
    });
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!player.hidden)close();});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abc-site-tweaks"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Hide the Home item. CSS covers the plain "/" case; this catches localised roots
    // ("/hr", "/en-GB") that an attribute selector cannot express.
    function hideHome() {
      document.querySelectorAll('.header-section li > a[href]').forEach(function (a) {
        var path;
        try { path = new URL(a.href, location.origin).pathname; } catch (e) { return; }
        if (!/^\/([a-z]{2}(-[a-z]{2})?)?\/?$/i.test(path)) return;
        var li = a.closest('li');
        if (li) li.setAttribute('data-abc-hide-home', '');
      });
    }

    // The "More" button is hidden by CSS; anything parked behind it would vanish too,
    // so put those items back in the row.
    function unpark() {
      document.querySelectorAll('.header-section overflow-list > li[slot="overflow"]').forEach(function (li) {
        if (li.querySelector(':scope > button[aria-haspopup]')) return;
        li.removeAttribute('slot');
      });
    }

    function run() { hideHome(); unpark(); }
    run();

    // Rule 8. Runs once per page: the anchor and the booking section are both server
    // rendered, so there is nothing to keep re-checking.
    function moveBookAnchor() {
      var anchor = document.getElementById('abc-wk-book');
      if (!anchor) return;
      var booking = document.querySelector('[id^="shopify-section-"][id$="__booking"]');
      if (!booking || anchor.nextElementSibling === booking) return;
      booking.parentNode.insertBefore(anchor, booking);
    }
    moveBookAnchor();
    document.addEventListener('DOMContentLoaded', moveBookAnchor);

    var host = document.querySelector('.header-section');
    if (host) {
      new MutationObserver(run).observe(host, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['slot']
      });
    }
    window.addEventListener('resize', run);
    window.addEventListener('load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abc-tier-stamp"] && !Shopify.designMode) return;
  try {
    
  // Retime the Collector card's ink mark.
  //
  // artbeat-community.liquid fades the mark in at offset .47-.52 of a 1600ms run, but
  // the stamp is still down on the card until .51 - so you watch the mark appear from
  // under a seal that has not moved yet. The mark should only show once the seal lifts.
  //
  // The mark is driven by the Web Animations API, which CSS cannot override, so the
  // animation is replaced rather than restyled. Running inside requestAnimationFrame
  // puts this after whichever click handler created it, without depending on the order
  // the two sections' scripts happen to be bundled in.
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const root = event.target.closest('[data-ab-community]');
    if (!root) return;
    if (!event.target.closest('[data-abc-tier], [data-collector-replay], [data-sim-action]')) return;
    const card = root.querySelector('[data-abc-collector]');
    if (!card) return;
    const ink = card.querySelector('[data-collector-ink]');
    const reduced = card.querySelector('[data-collector-reduced]');
    if (!ink) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || (reduced && reduced.checked)) return;
    requestAnimationFrame(() => {
      const running = ink.getAnimations();
      if (!running.length) return;
      running.forEach(animation => animation.cancel());
      ink.animate([
        { opacity: 0, transform: 'scale(1.04)', offset: 0 },
        { opacity: 0, transform: 'scale(1.04)', offset: .60 },
        { opacity: .85, transform: 'scale(.99)', offset: .70 },
        { opacity: 1, transform: 'scale(1)', offset: .80 },
        { opacity: 1, transform: 'scale(1)', offset: 1 }
      ], { duration: 1600, fill: 'forwards' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["abc-workshop-signup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Point "Choose a date" at this form while the calendar is off the page. When the
    // calendar section is back, its wrapper id ends in __booking and this does nothing.
    function retarget() {
      var signup = document.getElementById('abc-wk-signup');
      if (!signup) return;
      if (document.querySelector('[id^="shopify-section-"][id$="__booking"]')) return;
      var label = signup.getAttribute('data-cta-label') || 'Sign up';
      document.querySelectorAll('.abc-wk-cta a').forEach(function (a) {
        a.setAttribute('href', '#abc-wk-signup');
        a.textContent = label + ' ↓';
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', retarget);
    else retarget();
    document.addEventListener('shopify:section:load', retarget);

    // Append the phone to the tags as tel:<digits>. Rebuilt from the original tag list
    // every time, so a second submit attempt never stacks two numbers. Capture phase, so
    // it runs before the browser posts the form.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.id !== 'abc-wk-signup-form') return;
      var tags = form.querySelector('input[name="contact[tags]"]');
      var phone = form.querySelector('input[data-abc-phone]');
      if (!tags || !phone) return;
      var base = tags.getAttribute('data-base');
      if (base === null) { base = tags.value; tags.setAttribute('data-base', base); }
      var digits = (phone.value || '').trim().replace(/[^\d+]/g, '').replace(/(?!^)\+/g, '');
      tags.value = digits ? base + ', tel:' + digits : base;
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artbeat-community"] && !Shopify.designMode) return;
  try {
    
  function abcSelect(root, name, focus = false) {
    const selected = root.querySelector(`[data-abc-tab="${name}"]`);
    if (!selected) return;
    root.querySelectorAll('[data-abc-tab]').forEach(tab => { const active=tab===selected; tab.setAttribute('aria-selected',String(active)); tab.tabIndex=active?0:-1; });
    root.querySelectorAll('[data-abc-panel]').forEach(panel => { panel.hidden=panel.dataset.abcPanel!==name; });
    if (focus) { selected.focus(); selected.scrollIntoView({block:'nearest',inline:'nearest'}); }
  }
  document.addEventListener('click',event=>{
    if (!(event.target instanceof Element)) return;
    const root=event.target.closest('[data-ab-community]'); if (!root) return;
    if(event.target.closest('[data-abc-demo]')){const demo=root.querySelector('[data-abc-simulator]');demo.focus();demo.scrollIntoView({block:'start'});}
    const tab=event.target.closest('[data-abc-tab]'); if (tab) abcSelect(root,tab.dataset.abcTab);
    const opener=event.target.closest('[data-abc-open]'); if (opener) abcSelect(root,opener.dataset.abcOpen,true);
    const join=event.target.closest('[data-abc-join]'); if (join) { const panel=root.querySelector('.abc-join'); panel.hidden=!panel.hidden;join.setAttribute('aria-expanded',String(!panel.hidden));if(!panel.hidden)panel.focus(); }
    if (event.target.closest('[data-abc-close]')) {root.querySelector('.abc-join').hidden=true;const button=root.querySelector('[data-abc-join]');button.setAttribute('aria-expanded','false');button.focus();}
    const tier=event.target.closest('[data-abc-tier]'); if (tier) {root.querySelectorAll('[data-abc-tier]').forEach(button=>button.setAttribute('aria-pressed',String(button===tier)));root.querySelectorAll('[data-abc-balance]').forEach(panel=>{panel.hidden=panel.dataset.abcBalance!==tier.dataset.abcTier;});}
  });
  document.addEventListener('keydown',event=>{
    if (!(event.target instanceof Element)) return;
    const tab=event.target.closest('[data-abc-tab]'); if (!tab) return;
    const root=tab.closest('[data-ab-community]'),tabs=[...root.querySelectorAll('[data-abc-tab]')];let index=tabs.indexOf(tab);
    if(event.key==='ArrowRight')index=(index+1)%tabs.length;else if(event.key==='ArrowLeft')index=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')index=0;else if(event.key==='End')index=tabs.length-1;else return;
    event.preventDefault();abcSelect(root,tabs[index].dataset.abcTab,true);
  });
function abcSimInitial(){return {orders:[],tier:0,confirmed:0,pending:0};}
function abcSimStep(previous,action){
 const state=structuredClone(previous);
 if(action.type==='reset')return abcSimInitial();
 if(action.type==='buy'&&state.orders.length<30){const cents={print:12550,canvas:120000}[action.product];if(cents)state.orders.push({id:state.orders.length+1,cents,remaining:cents,confirmed:false,half:false});}
 if(action.type==='confirm')state.orders.forEach(order=>{order.confirmed=true;});
 const order=state.orders.find(order=>order.id===action.id);
 if(order&&action.type==='half'&&!order.half&&order.remaining>0){order.remaining=Math.floor(order.cents/2);order.half=true;}
 if(order&&action.type==='full')order.remaining=0;
 state.confirmed=state.orders.filter(o=>o.confirmed).reduce((sum,o)=>sum+Math.floor(o.remaining/100),0);
 state.pending=state.orders.filter(o=>!o.confirmed).reduce((sum,o)=>sum+Math.floor(o.remaining/100),0);
 state.tier=Math.max(state.tier,[0,1000,5000,20000].filter(n=>state.confirmed>=n).length-1);
 return state;
}
const abcSimStates=new WeakMap();
function abcSimRender(root,state){
 const area=root.querySelector('[data-abc-simulator]');if(!area)return;
 const text=key=>area.querySelector(`[data-sim-copy="${key}"]`).textContent;
 const number=new Intl.NumberFormat(document.documentElement.lang||'en');
 const money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:'EUR'});
 area.querySelector('[data-sim-confirmed]').textContent=number.format(state.confirmed);
 area.querySelector('[data-sim-pending]').textContent=number.format(state.pending);
 area.querySelector('[data-sim-tier]').textContent=text('tier'+state.tier);
 area.querySelector('[data-sim-action="confirm"]').disabled=!state.orders.some(o=>!o.confirmed&&o.remaining>0);
 const list=area.querySelector('[data-sim-orders]');list.replaceChildren();
 if(!state.orders.length){const p=document.createElement('p');p.textContent=text('empty');list.append(p);}
 for(const order of state.orders){
  const row=document.createElement('article');row.className='abc-sim-order';
  const title=document.createElement('h4');title.textContent=`${text('order')} ${String(order.id).padStart(2,'0')} · ${money.format(order.cents/100)}`;
  const p=document.createElement('p');p.textContent=`${text('kept')}: ${money.format(order.remaining/100)} · ${Math.floor(order.remaining/100)} ${text('points')} · ${text(order.remaining===0?'refunded':order.confirmed?'confirmed':'pending')}`;
  row.append(title,p);
  for(const type of ['half','full']){const button=document.createElement('button');button.type='button';button.className='abc-link';button.dataset.simAction=type;button.dataset.simId=String(order.id);button.textContent=text(type);button.disabled=order.remaining===0||(type==='half'&&order.half);row.append(button);}
  list.append(row);
 }
 area.querySelector('[data-sim-status]').textContent=text(state.orders.length>=30?'limit':'change');
}
document.addEventListener('click',event=>{
 if(!(event.target instanceof Element))return;
 const button=event.target.closest('[data-sim-action]');if(!button)return;
 const root=button.closest('[data-ab-community]');if(!root)return;
 const previous=abcSimStates.get(root)||abcSimInitial();
 const state=abcSimStep(previous,{type:button.dataset.simAction,product:button.dataset.simProduct,id:Number(button.dataset.simId)});
 abcSimStates.set(root,state);abcSimRender(root,state);
 if(state.tier>previous.tier){abcSelect(root,"tiers");abcCollectorUpdate(root,state.tier,true,true);}
 else if(button.dataset.simAction==="reset")abcCollectorUpdate(root,0,false);
});

const abcCollectorRuns=new WeakMap();
function abcCollectorUpdate(root,tier,animate=false,earned=false,scroll=true){
 const card=root.querySelector('[data-abc-collector]');if(!card)return;
 const index=Math.min(3,Math.max(0,Number(tier)||0));
 const title=root.querySelector(`[data-sim-copy="tier${index}"]`).textContent;
 const stage=card.querySelector('[data-stamp-stage]');abcWritingStop(stage);const previous=abcCollectorRuns.get(card);if(previous)clearTimeout(previous.timer);
 card.dataset.collectorTier=String(index);
 card.dataset.collectorEarned=String(earned);
 ['heading','card-tier','ink-tier'].forEach(key=>card.querySelector(`[data-collector-${key}]`).textContent=title);
 card.querySelector('[data-collector-edition]').textContent=`0${index+1} / 04`;
 const copy=key=>card.querySelector(`[data-collector-copy="${key}"]`).textContent;
 card.querySelector('[data-collector-source]').textContent=copy(earned?'earned':'preview');
 card.querySelectorAll('[data-collector-seal]').forEach(img=>{img.hidden=Number(img.dataset.collectorSeal)!==index;});
 const status=card.querySelector('[data-collector-status]');status.textContent='';
 const announce=()=>{status.textContent=`${earned?copy('announce')+': '+title+'. ':''}${copy('status')}`;};
 abcWritingSvg(card.querySelector('[data-writing]'));
 if(animate){if(scroll)stage.scrollIntoView({block:'center',behavior:'auto'});abcWritingPlay(stage,announce);}else announce();

}
document.addEventListener('input',event=>{
 if(!(event.target instanceof HTMLInputElement)||!event.target.matches('[data-collector-input]'))return;
 const card=event.target.closest('[data-abc-collector]');card.querySelector('[data-collector-name]').textContent=event.target.value.trim()||card.querySelector('[data-collector-copy="default"]').textContent;card.classList.toggle('abc-long-name',event.target.value.trim().length>24);
});
document.addEventListener('change',event=>{
 if(!(event.target instanceof Element)||!event.target.matches('[data-collector-reduced]'))return;
 const root=event.target.closest('[data-ab-community]');[...abcWritingRuns.keys()].forEach(host=>abcWritingStop(host));const card=root.querySelector('[data-abc-collector]');abcCollectorUpdate(root,card.dataset.collectorTier,false,card.dataset.collectorEarned==='true');
});
document.addEventListener('click',event=>{
 if(!(event.target instanceof Element))return;const root=event.target.closest('[data-ab-community]');if(!root)return;
 const tier=event.target.closest('[data-abc-tier]');if(tier){abcCollectorUpdate(root,Number(tier.dataset.abcTier)-1,false);abcWritingPlay(tier.querySelector('[data-tier-writing]'));}
 if(event.target.closest('[data-collector-replay]')){const card=root.querySelector('[data-abc-collector]');abcCollectorUpdate(root,card.dataset.collectorTier,true,card.dataset.collectorEarned==='true');}
});

const abcWritingStrokes=[
 ['M104 138 C86 128 67 137 69 152 C68 174 96 178 103 153',18],
 ['M75 125 C66 115 88 106 100 118 C105 124 103 148 104 161 Q104 173 115 167',17],
 ['M114 121 Q123 115 121 130 L121 161 Q121 169 132 169',18],
 ['M121 132 Q122 108 145 121 L145 129',15],
 ['M158 111 L158 151 Q157 176 180 163',20],
 ['M143 119 L173 117',12],
 ['M178 99 L184 98 L184 150 Q184 165 178 167',17],
 ['M185 123 C197 109 209 116 216 135 C225 166 210 183 185 161',20],
 ['M226 140 L259 133 C256 109 231 106 225 130 C216 152 234 179 257 164',18],
 ['M300 138 C278 126 261 138 264 154 C266 176 293 177 300 152',18],
 ['M272 125 C263 114 288 106 298 120 Q301 128 300 161 Q300 173 309 166',17],
 ['M314 111 L314 152 Q313 175 329 164',18],
 ['M302 119 L329 117',12]
];
let abcWritingId=0;
const abcWritingRuns=new Map();
// The written wordmark takes its tier's own metal, so the four tiers read as four
// different things rather than the same black logo four times. feColorMatrix keeps the
// logo's alpha and replaces only its colour - it works wherever SVG renders at all,
// unlike mask-type:alpha or a hue-rotate filter chain.
const abcTones=['#333333','#73502c','#65707a','#92702b'];
function abcToneRgb(hex){const n=parseInt(hex.slice(1),16);return [(n>>16&255)/255,(n>>8&255)/255,(n&255)/255].map(v=>v.toFixed(4));}
function abcWritingIndex(mark){
 const card=mark.closest('[data-abc-tier]');
 if(card)return Math.min(3,Math.max(0,(Number(card.dataset.abcTier)||1)-1));
 const collector=mark.closest('[data-abc-collector]');
 if(collector)return Math.min(3,Math.max(0,Number(collector.dataset.collectorTier)||0));
 return 0;
}
function abcWritingSvg(mark){
 const tone=abcToneRgb(abcTones[abcWritingIndex(mark)]);
 const matrix='0 0 0 0 '+tone[0]+' 0 0 0 0 '+tone[1]+' 0 0 0 0 '+tone[2]+' 0 0 0 1 0';
 // The collector card is redrawn as the tier changes, so retint rather than rebuild.
 const existing=mark.querySelector('svg');
 if(existing){const m=existing.querySelector('feColorMatrix');if(m)m.setAttribute('values',matrix);return existing;}
 const ns='http://www.w3.org/2000/svg',make=(tag,attrs)=>{const el=document.createElementNS(ns,tag);Object.entries(attrs).forEach(([k,v])=>el.setAttribute(k,v));return el;};
 const svg=make('svg',{viewBox:'54 87 288 92','aria-hidden':'true'}),defs=make('defs',{}),id='abc-writing-'+(++abcWritingId);
 const mask=make('mask',{id,maskUnits:'userSpaceOnUse',x:50,y:85,width:300,height:95});
 abcWritingStrokes.forEach(([d,width])=>mask.append(make('path',{d,fill:'none',stroke:'white','stroke-width':width,'stroke-linecap':'round','stroke-linejoin':'round','data-writing-stroke':''})));
 const tint=make('filter',{id:id+'-tone','color-interpolation-filters':'sRGB'});
 tint.append(make('feColorMatrix',{type:'matrix',values:matrix}));
 defs.append(mask);defs.append(tint);svg.append(defs);
 svg.append(make('image',{href:mark.dataset.logoUrl,x:0,y:0,width:400,height:283,mask:'url(#'+id+')',filter:'url(#'+id+'-tone)'}));
 mark.replaceChildren(svg);return svg;
}
function abcWritingStop(host,complete=true){
 const run=abcWritingRuns.get(host);if(run){cancelAnimationFrame(run.frame);abcWritingRuns.delete(host);}
 host.classList.remove('abc-writing-active');
 const mark=host.querySelector('[data-writing]');
 if(mark)mark.querySelectorAll('[data-writing-stroke]').forEach(p=>{p.style.strokeDashoffset='0';p.style.opacity=complete?'1':'0';});
 const tool=host.querySelector('[data-writing-tool]');if(tool){tool.style.transform='';tool.style.opacity='';}
}
function abcWritingPlay(host,onComplete){
 abcWritingStop(host);
 const mark=host.querySelector('[data-writing]'),tool=host.querySelector('[data-writing-tool]');if(!mark||!tool)return;
 const svg=abcWritingSvg(mark),paths=[...svg.querySelectorAll('[data-writing-stroke]')];
 const root=host.closest('[data-ab-community]');
 if(matchMedia('(prefers-reduced-motion: reduce)').matches||root.querySelector('[data-collector-reduced]')?.checked){abcWritingStop(host,true);host.classList.add('abc-writing-finished');onComplete?.();return;}
 host.classList.remove('abc-writing-finished');host.classList.add('abc-writing-active');
 const measures=paths.map(path=>({path,length:path.getTotalLength()})),total=measures.reduce((sum,s)=>sum+s.length,0);
 const segments=[];let cursor=160,prior=measures[0].path.getPointAtLength(0);
 measures.forEach(({path,length})=>{
  path.style.strokeDasharray=String(length);path.style.strokeDashoffset=String(length);path.style.opacity='0';
  const start=path.getPointAtLength(0),duration=length/total*5100;
  segments.push({start:cursor,end:cursor+90,from:prior,to:start});cursor+=90;
  segments.push({start:cursor,end:cursor+duration,path,length});cursor+=duration;prior=path.getPointAtLength(length);
 });
 const run={frame:0};abcWritingRuns.set(host,run);let started;
 const frame=now=>{
  if(started===undefined)started=now;
  const elapsed=now-started;
  const hostBox=host.getBoundingClientRect(),box=mark.getBoundingClientRect(),scale=box.width/288;
  let point=measures[0].path.getPointAtLength(0),lift=Math.max(0,1-elapsed/160)*16;
  for(const segment of segments){
   if(elapsed<segment.start)break;
   const p=Math.min(1,(elapsed-segment.start)/(segment.end-segment.start));
   if(segment.path){segment.path.style.opacity='1';segment.path.style.strokeDashoffset=String(segment.length*(1-p));point=segment.path.getPointAtLength(segment.length*p);lift=0;}
   else{point={x:segment.from.x+(segment.to.x-segment.from.x)*p,y:segment.from.y+(segment.to.y-segment.from.y)*p};lift=Math.sin(p*Math.PI)*11;}
  }
  const finishing=Math.max(0,Math.min(1,(elapsed-cursor)/220));
  const width=host.matches('[data-tier-writing]')?host.clientWidth*.64:tool.offsetWidth;
  const x=box.left-hostBox.left+(point.x-54)*scale-width*.14;
  const y=box.top-hostBox.top+(point.y-87)*scale-width*.88-lift-finishing*22;
  tool.style.transform=host.matches('[data-tier-writing]')?'translate('+x+'px,'+y+'px) scale(.64)':'translate('+x+'px,'+y+'px)';
  tool.style.opacity=String(Math.min(1,elapsed/120)*(1-finishing));
  host.dataset.writingStroke=String(segments.filter(s=>s.path&&elapsed>=s.start).length);
  if(elapsed<cursor+220){run.frame=requestAnimationFrame(frame);return;}
  abcWritingStop(host);host.classList.add('abc-writing-finished');onComplete?.();
 };
 run.frame=requestAnimationFrame(frame);
}
document.addEventListener('pointerover',event=>{
 if(event.pointerType==='touch'||!(event.target instanceof Element))return;
 const art=event.target.closest('[data-tier-writing]');if(art&&!art.contains(event.relatedTarget))abcWritingPlay(art);
 const paper=event.target.closest('[data-collector-paper]');if(paper&&!paper.contains(event.relatedTarget)){
  const root=paper.closest('[data-ab-community]'),card=root.querySelector('[data-abc-collector]');abcCollectorUpdate(root,card.dataset.collectorTier,true,card.dataset.collectorEarned==='true',false);
 }
});
document.addEventListener('pointerout',event=>{
 if(!(event.target instanceof Element))return;const art=event.target.closest('[data-tier-writing]');
 if(art&&!art.contains(event.relatedTarget)){abcWritingStop(art);art.classList.remove('abc-writing-finished');}
});
document.addEventListener('focusin',event=>{if(!(event.target instanceof Element))return;const tier=event.target.closest('[data-abc-tier]');if(tier&&tier.matches(':focus-visible'))abcWritingPlay(tier.querySelector('[data-tier-writing]'));});
document.addEventListener('focusout',event=>{if(!(event.target instanceof Element))return;const tier=event.target.closest('[data-abc-tier]');if(tier&&!tier.contains(event.relatedTarget)){const art=tier.querySelector('[data-tier-writing]');abcWritingStop(art);art.classList.remove('abc-writing-finished');}});
document.addEventListener('visibilitychange',()=>{if(document.hidden)[...abcWritingRuns.keys()].forEach(host=>abcWritingStop(host));});
window.addEventListener('resize',()=>[...abcWritingRuns.keys()].forEach(host=>abcWritingStop(host)));

// The card writes itself as it scrolls into view. Before this the strokes were drawn
// the moment the SVG was built, so the wordmark was simply already there and the only
// way to see it written was a button - which did nothing at all when the visitor's
// system asked for reduced motion.
function abcWritingOnScroll(){
 const stages=[...document.querySelectorAll('[data-stamp-stage]')];
 if(!stages.length)return;
 stages.forEach(stage=>{const mark=stage.querySelector('[data-writing]');if(mark){abcWritingSvg(mark);abcWritingStop(stage,false);}});
 if(!('IntersectionObserver' in window)){stages.forEach(stage=>abcWritingPlay(stage));return;}
 const io=new IntersectionObserver((entries,obs)=>{
  entries.forEach(entry=>{
   if(!entry.isIntersecting)return;
   obs.unobserve(entry.target);
   abcWritingPlay(entry.target);
  });
 },{threshold:0.4});
 stages.forEach(stage=>io.observe(stage));
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',abcWritingOnScroll);else abcWritingOnScroll();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artbeat-loyalty-preview"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-sample-tier]');
    const section = button?.closest('[data-artbeat-tier-preview]');
    if (!section) return;
    const tier = button.dataset.sampleTier;
    section.querySelectorAll('[data-sample-tier]').forEach((item) => {
      item.setAttribute('aria-pressed', String(item === button));
    });
    section.querySelectorAll('[data-sample-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.samplePanel !== tier;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
